// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'

Vue.use(ElementUI, {size: 'small'})
Vue.config.productionTip = false
Vue.prototype.axios = axios
axios.defaults.baseURL = '/'
axios.defaults.headers.post['Content-Type'] = 'application/json'

Vue.use(Vuex)
// 因为页面比较简单 所以第二版中并未使用store
// 使用了keepAlive的方式简单处理 详见router/index.js
// mengxue
var store = new Vuex.Store({
  state: {
    token: '',
    userId: '',
    formIos: '',
    formAndroid: '',
    currentTab: '',
    iosTableData: '',
    androidTableData: '',
    currentPageIos: 1,
    currentPageSizeIos: 10,
    currentPageAndroid: 1,
    currentPageSizeAndroid: 10,
    totalCountAndroid: '',
    totalCountIos: '',
    formData: {}
  },
  mutations: {
    addToken (state, token) {
      sessionStorage.setItem('token', token)
      state.token = token
    },
    removeCount (state, token) {
      sessionStorage.removeItem('token', token)
      state.token = token
    },
    formIosState (state, form) {
      sessionStorage.setItem('formIos', form)
      state.formIos = form
    },
    formAndroidState (state, form) {
      sessionStorage.setItem('formAndroid', form)
      state.formAndroid = form
    },
    currentTabState (state, tab) {
      sessionStorage.setItem('currentTab', tab)
      state.currentTab = tab
    },
    iosTable (state, data) {
      sessionStorage.setItem('iosTableData', data)
      state.iosTableData = data
    },
    androidTable (state, data) {
      sessionStorage.setItem('androidTableData', data)
      state.androidTableData = data
    },
    iosPage (state, page) {
      sessionStorage.setItem('currentPageIos', page)
      state.currentPageIos = page
    },
    androidPage (state, page) {
      sessionStorage.setItem('currentPageAndroid', page)
      state.currentPageAndroid = page
    },
    iosPageSize (state, size) {
      sessionStorage.setItem('currentPageSizeIos', size)
      state.currentPageSizeIos = size
    },
    androidPageSize (state, size) {
      sessionStorage.setItem('currentPageSizeAndroid', size)
      state.currentPageSizeAndroid = size
    },
    androidCount (state, count) {
      sessionStorage.setItem('totalCountAndroid', count)
      state.totalCountAndroid = count
    },
    iosCount (state, count) {
      sessionStorage.setItem('totalCountIos', count)
      state.totalCountIos = count
    },
    formDataChange (state, data) {
      state.formData = data
    }
  }
})

router.beforeEach((to, from, next) => {
  store.state.token = sessionStorage.getItem('token')
  console.log('token = ' + store.state.token)
  if (to.meta.requireAuth) {
    if (store.state.token !== '' && store.state.token !== 'null' && store.state.token !== null) {
      next()
    } else {
      next()
      /** next({
        path: '/login',
        query: {redirect: to.fullPath}
      })**/
    }
  } else {
    next()
  }
})

let vRouter = new Vue({
  store,
  router,
  el: '#app',
  render: h => h(App)
})
Vue.use({
  vRouter
})



// WEBPACK FOOTER //
// ./src/main.js